import React from 'react';

import {BrowserRouter, Switch, Route} from "react-router-dom";
import {Container, Row, Col, Image} from 'react-bootstrap';
import StartConsignment from './StartConsignment';
import ConsignItemForm from './ConsignItemForm';
import ConsignedItems from './ConsignedItems';
import ConsignerForm from './ConsignerForm';
import ConsignmentConfirmation from './ConsignmentConfirmation';
import ResumeConsignment from './ResumeConsignment';
import ConsignmentOver from './ConsignmentOver';
import ProtectedRoute from './components/ProtectedRoute';
import AdminApp from './admin/AdminApp';
import './App.css';

class ConsignmentApp extends React.Component {
  constructor(props) {
    super(props);

    console.log(`Creating new instance of ConsignmentApp in ${process.env.REACT_APP_ENV} env`);

    this.state = {
      consignerInfo: {}
    }

    this.updateConsignerInfo = this.updateConsignerInfo.bind(this);
    this.getConsignerInfo = this.getConsignerInfo.bind(this);
    this.clearState = this.clearState.bind(this);
    this.getAuth = this.getAuth.bind(this);
    this.setAuth = this.setAuth.bind(this);
  }

  getAuth = () => {
    return JSON.parse(localStorage.getItem("auth"));
  }

  setAuth = (auth) => {
    localStorage.setItem("auth", JSON.stringify(auth));
  }

  updateConsignerInfo(consignerInfo) {
    localStorage.setItem("consignerInfo", JSON.stringify(consignerInfo));
  }

  getConsignerInfo() {
    return JSON.parse(localStorage.getItem("consignerInfo"));
  }

  clearState() {
    // Only the consigner session; an admin signed in on the same browser stays signed in
    localStorage.removeItem("auth");
    localStorage.removeItem("consignerInfo");
  }

  render() {
    return (
      <BrowserRouter>
        <Switch>
          {/* Admin pages use their own layout and sign-in, outside the consigner status guard */}
          <Route path="/admin" component={AdminApp} />
          <Route render={() => (
            <Container fluid>
              <Row className="header, justify-content-md-center">
                <Col sm={2}>
                  <Image className="cochrans-logo" src="cochrans_symbol.png" fluid/>
                </Col>
                <Col sm={8}>
                  <h1 className="cochrans-title">Cochran's Ski & Ride Sale</h1>
                </Col>
              </Row>
              <Row className="justify-content-md-center">
                <Col sm={8}>
                  <hr/>
                </Col>
              </Row>
              <Row className="justify-content-md-center">
                <Col sm={8}>
                  <Switch>
                    {/* Uncomment the route below to manually close the sale */}
                    {/* <Route exact path="/over"
                      render={
                        props => <ConsignmentOver  />
                      }
                    /> */}
              
                    <ProtectedRoute exact path="/"
                      render={
                        props => <StartConsignment {...props}  updateConsignerInfo={this.updateConsignerInfo} />
                      }
                    />

                     <ProtectedRoute exact path="/login"
                      render={
                        props => <ConsignerForm {...props} updateConsignerInfo={this.updateConsignerInfo} />
                      }
                    />

                    <ProtectedRoute exact path="/consignerinfo"
                      render={
                        props => <ConsignerForm {...props} updateConsignerInfo={this.updateConsignerInfo} setAuth={this.setAuth}/>
                      }
                    />

                    <ProtectedRoute exact path="/consignitem"
                      render={
                        props => <ConsignItemForm {...props} getAuth={this.getAuth}/>
                      }
                    />

                    <ProtectedRoute exact path="/consigneditems"
                      render={
                         props => <ConsignedItems {...props} getConsignerInfo={this.getConsignerInfo} setAuth={this.setAuth} getAuth={this.getAuth} updateConsignerInfo={this.updateConsignerInfo}/>
                      }
                    />

                    <ProtectedRoute exact path="/consignmentconfirmation"
                      render={
                         props => <ConsignmentConfirmation {...props} getConsignerInfo={this.getConsignerInfo} getAuth={this.getAuth} clearState={this.clearState}/>
                      }
                    />

                    <ProtectedRoute exact path="/resumeconsignment"
                      render={
                        props => <ResumeConsignment {...props}  updateConsignerInfo={this.updateConsignerInfo} clearState={this.clearState} setAuth={this.setAuth}/>
                      }
                    />
                  </Switch>
                </Col>
              </Row>
            </Container>
          )} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default ConsignmentApp;
